module.exports = __webpack_public_path__ + "media/cpzs.50ec19ba.mp4";